import localforage from "localforage";
import axios from "../api/axios";
import { useAuth } from "./useAuth";

export const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {
    const response = await axios.get("/refresh", {
      withCredentials: true,
    });
    localforage.setItem("auth", response.data);
    setAuth((prev) => {
      return {
        ...prev,
        accessToken: response.data.access_token,
        roles: response.data.roles,
      };
    });
    return response.data.access_token;
  };
  return refresh;
};
